import clsx from "clsx";
import React, { useState } from "react";
import "./styles.scss";

interface FilterProps {
  onClick: () => void;
  name: string;
  isActive?: boolean;
  color: string;
}

export const Filter = (props: FilterProps): JSX.Element => {
  const { onClick, name, isActive, color } = props;
  const [hovered, setHovered] = useState(false);
  const toggleHover = () => setHovered(!hovered);
  return (
    <div
      className="filter"
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
    >
      <li>
        <button
          type="button"
          onClick={onClick}
          style={isActive || hovered ? { backgroundColor: color } : {}}
          className={clsx((isActive || hovered) && "active")}
        >
          <h6>{name}</h6>
        </button>
      </li>
    </div>
  );
};

Filter.defaultProps = {
  isActive: false,
};
